<template>
  <svg class="icon-plus-sign" v-bind:class="{'icon-plus-sign--active': isActive}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path class="icon-plus-sign__border" d="M0 0v24h24V0H0zm2.6667 2.6667h18.6666v18.6666H2.6667V2.6667z"/>
    <path class="icon-plus-sign__plus" d="M10.6667 5.3333v5.3334H5.3333v2.6666h5.3334v5.3334h2.6666v-5.3334h5.3334v-2.6666h-5.3334V5.3333z"/>
  </svg>
</template>

<script>
export default {
  props: {
    isActive: Boolean
  }
};
</script>

<style lang="scss">
.icon-plus-sign {
  &__plus {
    transition: all 0.2s ease;
    transform: rotate(0);
    transform-origin: 50% 50%;
    .icon-plus-sign--active & {
      transform: rotate(45deg);
    }
  }
}
</style>
